import { render, staticRenderFns } from "./kindChooseViewkvipSeventh.vue?vue&type=template&id=6f1ed8a2&scoped=true"
import script from "./kindChooseViewkvipSeventh.vue?vue&type=script&lang=js"
export * from "./kindChooseViewkvipSeventh.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewkvipSeventh.vue?vue&type=style&index=0&id=6f1ed8a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ed8a2",
  null
  
)

export default component.exports